import * as React from 'react';

import IconPlus from '-!svg-react-loader!../containers/Html/icons/plus.svg';
import IconPlusThin from '-!svg-react-loader!../containers/Html/icons/plus_thin.svg';
import IconFollowers from '-!svg-react-loader!../containers/Html/icons/followers.svg';
import IconPfpDefault from '-!svg-react-loader!../containers/Html/icons/pfp_default.svg';
import IconPfpSalon from '-!svg-react-loader!../containers/Html/icons/pfp_salon.svg';
import IconSmileHappy from '-!svg-react-loader!../containers/Html/icons/smile-happy-t.svg';
import IconMissing from '-!svg-react-loader!../containers/Html/icons/missing.svg';
import IconEdit from '-!svg-react-loader!../containers/Html/icons/edit.svg';
import IconSearchHeader from '-!svg-react-loader!../containers/Html/icons/search-header.svg';
import IconBag from '-!svg-react-loader!../containers/Html/icons/bag.svg';
import IconNotify from '-!svg-react-loader!../containers/Html/icons/notify.svg';
import IconHamby0 from '-!svg-react-loader!../containers/Html/icons/hamby0.svg';
import IconHamby1 from '-!svg-react-loader!../containers/Html/icons/hamby1.svg';
import IconSubmenu from '-!svg-react-loader!../containers/Html/icons/submenu.svg';
import IconBack from '-!svg-react-loader!../containers/Html/icons/back.svg';
import IconPrevious from '-!svg-react-loader!../containers/Html/icons/previous.svg';
import IconNext from '-!svg-react-loader!../containers/Html/icons/next.svg';
import IconLogOut from '-!svg-react-loader!../containers/Html/icons/log_out.svg';
import Analytics from '-!svg-react-loader!../containers/Html/icons/analytics.svg';
import IconEditProfile from '-!svg-react-loader!../containers/Html/icons/edit_profile.svg';
import IconOpenSalon from '-!svg-react-loader!../containers/Html/icons/open_salon.svg';
import IconOrders from '-!svg-react-loader!../containers/Html/icons/orders.svg';
import IconProducts from '-!svg-react-loader!../containers/Html/icons/products.svg';
import IconCustomers from '-!svg-react-loader!../containers/Html/icons/customers.svg';
import IconAppointments from '-!svg-react-loader!../containers/Html/icons/appointments.svg';
import IconExit from '-!svg-react-loader!../containers/Html/icons/exit.svg';
import IconCancelSearch from '-!svg-react-loader!../containers/Html/icons/cancel_search.svg';
import LogoSymbol1 from '-!svg-react-loader!../containers/Html/icons/symbol1.svg';
import LogoSymbol2 from '-!svg-react-loader!../containers/Html/icons/symbol2.svg';
import IconStar1 from '-!svg-react-loader!../containers/Html/icons/star1.svg';
import IconUpload from '-!svg-react-loader!../containers/Html/icons/upload.svg';
import IconReduce from '-!svg-react-loader!../containers/Html/icons/reduce.svg';
import IconEnlarge from '-!svg-react-loader!../containers/Html/icons/enlarge.svg';
import IconHandle from '-!svg-react-loader!../containers/Html/icons/handle.svg';
import IconSearch3 from '-!svg-react-loader!../containers/Html/icons/search3.svg';
import IconSearch1 from '-!svg-react-loader!../containers/Html/icons/search1.svg';
import IconMore from '-!svg-react-loader!../containers/Html/icons/more.svg';
import IconMoreHorizontal from '-!svg-react-loader!../containers/Html/icons/more-options.svg';
import IconFilter from '-!svg-react-loader!../containers/Html/icons/filter.svg';
import IconAccordion from '-!svg-react-loader!../containers/Html/icons/accordion.svg';
import IconAccordionArrow from '-!svg-react-loader!../containers/Html/icons/accordion_arrow.svg';
import IconCheck from '-!svg-react-loader!../containers/Html/icons/check.svg';
import IconCheck1 from '-!svg-react-loader!../containers/Html/icons/check1.svg';
import IconCancel from '-!svg-react-loader!../containers/Html/icons/cancel.svg';
import IconEditPencil from '-!svg-react-loader!../containers/Html/icons/edit_pencil.svg';
import IconOff from '-!svg-react-loader!../containers/Html/icons/glossiq/toggle-off.svg';
import IconOn from '-!svg-react-loader!../containers/Html/icons/glossiq/toggle-on.svg';
import IconOffDisabled from '-!svg-react-loader!../containers/Html/icons/glossiq/toggle-off-disabled.svg';
import IconOnDisabled from '-!svg-react-loader!../containers/Html/icons/glossiq/toggle-on-disabled.svg';
import IconAlert from '-!svg-react-loader!../containers/Html/icons/glossiq/alert.svg';
import IconRating from '-!svg-react-loader!../containers/Html/icons/rating.svg';
import IconExpand from '-!svg-react-loader!../containers/Html/icons/glossiq/expand.svg';
import IconCollapse from '-!svg-react-loader!../containers/Html/icons/glossiq/collapse.svg';
import IconDelete from '-!svg-react-loader!../containers/Html/icons/glossiq/delete_2.svg';
import IconMoveUp from '-!svg-react-loader!../containers/Html/icons/move_up.svg';
import IconMoveDown from '-!svg-react-loader!../containers/Html/icons/move_down.svg';
import IconRemoveTag from '-!svg-react-loader!../containers/Html/icons/remove_tag.svg';
import IconAdd from '-!svg-react-loader!../containers/Html/icons/add.svg';
import IconViews from '-!svg-react-loader!../containers/Html/icons/views.svg';
import IconComments from '-!svg-react-loader!../containers/Html/icons/comments.svg';
import IconShare from '-!svg-react-loader!../containers/Html/icons/share.svg';
import IconLike from '-!svg-react-loader!../containers/Html/icons/like.svg';
import IconLiked from '-!svg-react-loader!../containers/Html/icons/liked.svg';
import IconSave from '-!svg-react-loader!../containers/Html/icons/save.svg';
import IconSaved from '-!svg-react-loader!../containers/Html/icons/saved.svg';
import IconDropdown from '-!svg-react-loader!../containers/Html/icons/dropdown.svg';
import IconFindMe from '-!svg-react-loader!../containers/Html/icons/findme.svg';
import IconLeft from '-!svg-react-loader!../containers/Html/icons/left.svg';
import IconRight from '-!svg-react-loader!../containers/Html/icons/right.svg';
import IconPinEmpty from '-!svg-react-loader!../containers/Html/icons/pin_empty.svg';
import IconFaucet from '-!svg-react-loader!../containers/Html/icons/faucet.svg';
import IconClock from '-!svg-react-loader!../containers/Html/icons/clock.svg';
import IconSlider from '-!svg-react-loader!../containers/Html/icons/slider-arrow.svg';
import IconArrowLeft from '-!svg-react-loader!../containers/Html/icons/arrow_left.svg';
import IconArrowLeftSmall from '-!svg-react-loader!../containers/Html/icons/arrow_left_small.svg';
import IconArrowRight from '-!svg-react-loader!../containers/Html/icons/arrow_right.svg';
import IconGreat from '-!svg-react-loader!../containers/Html/icons/glossiq/great.svg';
import SearchGo from '-!svg-react-loader!../containers/Html/icons/glossiq/search_go.svg';
import IconDeleteWhite from '-!svg-react-loader!../containers/Html/icons/glossiq/deleteWhite.svg';
import IconEditWhite from '-!svg-react-loader!../containers/Html/icons/glossiq/editWhite.svg';
import IconCopyCircle from '-!svg-react-loader!../containers/Html/icons/copy_circle.svg';
import IconS01 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-01.svg';
import IconS02 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-02.svg';
import IconS03 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-03.svg';
import IconS04 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-04.svg';
import IconS05 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-05.svg';
import IconS06 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-06.svg';
import IconS07 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-07.svg';
import IconS08 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-08.svg';
import IconS09 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-09.svg';
import IconS10 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-10.svg';
import IconS11 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-11.svg';
import IconS12 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-12.svg';
import IconS13 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-13.svg';
import IconS14 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-14.svg';
import IconS15 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-15.svg';
import IconS16 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-16.svg';
import IconS17 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-17.svg';
import IconS18 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-18.svg';
import IconS19 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-19.svg';
import IconS20 from '-!svg-react-loader!../containers/Html/icons/salon-types/s-20.svg';
import IconMarker_3 from '-!svg-react-loader!../containers/Html/icons/marker_3.svg';
import Airplane from '-!svg-react-loader!../containers/Html/icons/airplane.svg';
import Worktime from '-!svg-react-loader!../containers/Html/icons/glossiq/worktime.svg';
import DateFilter from '-!svg-react-loader!../containers/Html/icons/date_filter.svg';
import Edit2 from '-!svg-react-loader!../containers/Html/icons/edit2.svg';
import IconFacebook from '-!svg-react-loader!../containers/Html/icons/social/facebook-gray.svg';
import IconLinkedin from '-!svg-react-loader!../containers/Html/icons/social/linkedin-gray.svg';
import IconTwitter from '-!svg-react-loader!../containers/Html/icons/social/twitter-gray.svg';
import IconCopy from '-!svg-react-loader!../containers/Html/icons/actionIcons/link-gray.svg';
import IconArrowBlack from '-!svg-react-loader!../containers/Html/icons/arrow-black.svg';
import FooterIconFacebook from '-!svg-react-loader!../containers/Html/icons/social/facebook_footer_icon.svg';
import FooterIconLinkedin from '-!svg-react-loader!../containers/Html/icons/social/linkedin_footer_icon.svg';
import FooterIconInstagram from '-!svg-react-loader!../containers/Html/icons/social/instagram_footer_icon.svg';
import FooterIconTiktok from '-!svg-react-loader!../containers/Html/icons/social/tiktok_footer_icon.svg';
import FooterIconYoutube from '-!svg-react-loader!../containers/Html/icons/social/youtube_footer_icon.svg';
import FooterLogo from '-!svg-react-loader!../containers/Html/icons/glossiq/footerLogo.svg';
import IconRoundLeft from '-!svg-react-loader!../containers/Html/icons/round_left.svg';
import IconRoundRight from '-!svg-react-loader!../containers/Html/icons/round_right.svg';
import Options from '-!svg-react-loader!../containers/Html/icons/options.svg';
import Hamburger from '-!svg-react-loader!../containers/Html/icons/hamburger.svg';
import Hidden from '-!svg-react-loader!../containers/Html/icons/hidden.svg';
import Warning from '-!svg-react-loader!../containers/Html/icons/warning.svg';
import Delete from '-!svg-react-loader!../containers/Html/icons/delete.svg';
import SingleService from '-!svg-react-loader!../containers/Html/icons/singleService.svg';
import Bundle from '-!svg-react-loader!../containers/Html/icons/bundle.svg';
import Checked from '-!svg-react-loader!../containers/Html/icons/checked.svg';
import Unchecked from '-!svg-react-loader!../containers/Html/icons/unchecked.svg';
import PartiallyChecked from '-!svg-react-loader!../containers/Html/icons/partially_checked.svg';
import ToggleOn from '-!svg-react-loader!../containers/Html/icons/toggle_on.svg';
import ToggleOff from '-!svg-react-loader!../containers/Html/icons/toggle_off.svg';
import NikaPlus from '-!svg-react-loader!../containers/Html/icons/NikaPlus.svg';
import NikaMinus from '-!svg-react-loader!../containers/Html/icons/NikaMinus.svg';
import NikaWorktime from '-!svg-react-loader!../containers/Html/icons/worktime.svg';
import NikaCalendar from '-!svg-react-loader!../containers/Html/icons/calendar.svg';
import MoreVerticalGray from '-!svg-react-loader!../containers/Html/icons/more_vertical_gray.svg';
import Lightning from '-!svg-react-loader!../containers/Html/icons/lightning.svg';
import Coupon from '-!svg-react-loader!../containers/Html/icons/coupon.svg';
import UpDownArrows from '-!svg-react-loader!../containers/Html/icons/updownarrows.svg';
import LeftRoundNoborder from '-!svg-react-loader!../containers/Html/icons/left_round_noborder.svg';
import DiscountBadge from '-!svg-react-loader!../containers/Html/icons/discount_badge.svg';
import Quote from '-!svg-react-loader!../containers/Html/icons/nika_quote.svg';
import AppointmentPaid from '-!svg-react-loader!../containers/Html/icons/appointment_paid.svg';
import ExpandGroups from '-!svg-react-loader!../containers/Html/icons/glossiq/expandGroups.svg';
import ShrinkGroups from '-!svg-react-loader!../containers/Html/icons/glossiq/shrinkGroups.svg';
import LanuageSwitcherIcon from '-!svg-react-loader!../containers/Html/icons/language_switch.svg';
import ArrowLeftRound from '-!svg-react-loader!../containers/Html/icons/arrow_left_round.svg';
import ArrowRightRound from '-!svg-react-loader!../containers/Html/icons/arrow_right_round.svg';
import PlusUser from '-!svg-react-loader!../containers/Html/icons/plus_user.svg';
import SearchGray from '-!svg-react-loader!../containers/Html/icons/search_gray.svg';
import PfpDefault2 from '-!svg-react-loader!../containers/Html/icons/pfp_default2.svg';
import SearchNotFound from '-!svg-react-loader!../containers/Html/icons/search_not_found.svg';
import NewAppointment from '-!svg-react-loader!../containers/Html/icons/new_appointment.svg';
import BlockedTime from '-!svg-react-loader!../containers/Html/icons/blocked_time.svg';
import RecurringEvent from '-!svg-react-loader!../containers/Html/icons/recurring_event.svg';
import Notes from '-!svg-react-loader!../containers/Html/icons/notes.svg';
import LandingPageDownArrow from '-!svg-react-loader!../containers/Html/icons/landingpage/down_arrow.svg';
import LandingPageSearch from '-!svg-react-loader!../containers/Html/icons/landingpage/search.svg';
import LandingPageLocation from '-!svg-react-loader!../containers/Html/icons/landingpage/location.svg';

export const icons = {
	plus: IconPlus,
	plus_thin: IconPlusThin,
	followers: IconFollowers,
	pfp_default: IconPfpDefault,
	pfp_salon: IconPfpSalon,
	smile_happy: IconSmileHappy,
	missing: IconMissing,
	edit: IconEdit,
	search_header: IconSearchHeader,
	bag: IconBag,
	notify: IconNotify,
	hamby0: IconHamby0,
	hamby1: IconHamby1,
	hamburger: Hamburger,
	submenu: IconSubmenu,
	back: IconBack,
	exit: IconExit,
	previous: IconPrevious,
	next: IconNext,

	pin_empty: IconPinEmpty,
	faucet: IconFaucet,
	clock: IconClock,
	remove_tag: IconRemoveTag,
	add: IconAdd,
	log_out: IconLogOut,
	analytics: Analytics,
	edit_profile: IconEditProfile,
	open_salon: IconOpenSalon,
	orders: IconOrders,
	products: IconProducts,
	customers: IconCustomers,
	appointments: IconAppointments,
	cancel_search: IconCancelSearch,
	symbol1: LogoSymbol1,
	symbol2: LogoSymbol2,
	star1: IconStar1,
	rating: IconRating,
	upload: IconUpload,
	reduce: IconReduce,
	enlarge: IconEnlarge,
	handle: IconHandle,
	search3: IconSearch3,
	search1: IconSearch1,
	close: IconCancelSearch,
	more: IconMore,
	moreHorizontal: IconMoreHorizontal,
	filter: IconFilter,
	accordion: IconAccordion,
	accordion_arrow: IconAccordionArrow,
	check: IconCheck,
	check1: IconCheck1,
	cancel: IconCancel,
	editPencil: IconEditPencil,
	off: IconOff,
	on: IconOn,
	offDisabled: IconOffDisabled,
	onDisabled: IconOnDisabled,
	alert: IconAlert,
	expand: IconExpand,
	collapse: IconCollapse,
	delete_2: IconDelete,
	move_up: IconMoveUp,
	move_down: IconMoveDown,
	great: IconGreat,
	views: IconViews,
	comments: IconComments,
	share: IconShare,
	like: IconLike,
	liked: IconLiked,
	save: IconSave,
	saved: IconSaved,
	search_go: SearchGo,
	deleteWhite: IconDeleteWhite,
	editWhite: IconEditWhite,
	dropdown: IconDropdown,
	findme: IconFindMe,
	left: IconLeft,
	right: IconRight,
	sliderarrow: IconSlider,
	arrow_left: IconArrowLeft,
	arrow_left_small: IconArrowLeftSmall,
	arrow_right: IconArrowRight,
	copycircle: IconCopyCircle,
	airplane: Airplane,
	worktime: Worktime,
	datefilter: DateFilter,
	edit2: Edit2,
	facebook: IconFacebook,
	twitter: IconTwitter,
	linkedin: IconLinkedin,
	copyLink: IconCopy,
	arrowRight: IconArrowRight,
	arrowBlack: IconArrowBlack,
	facebookFooter: FooterIconFacebook,
	instagramFooter: FooterIconInstagram,
	linkedinFooter: FooterIconLinkedin,
	tiktokFooter: FooterIconTiktok,
	youtubeFooter: FooterIconYoutube,
	logoFooter: FooterLogo,
	roundLeft: IconRoundLeft,
	roundRight: IconRoundRight,
	options: Options,
	hidden: Hidden,
	warning: Warning,
	delete: Delete,
	singleService: SingleService,
	bundle: Bundle,
	checked: Checked,
	unchecked: Unchecked,
	partially_checked: PartiallyChecked,
	toggle_on: ToggleOn,
	toggle_off: ToggleOff,
	nikaPlus: NikaPlus,
	nikaMinus: NikaMinus,
	nikaWorktime: NikaWorktime,
	nikaCalendar: NikaCalendar,
	moreVerticalGray: MoreVerticalGray,
	lightning: Lightning,
	coupon: Coupon,
	upDownArrows: UpDownArrows,
	leftRoundNoborder: LeftRoundNoborder,
	discountBadge: DiscountBadge,
	quote: Quote,
	appointmentPaid: AppointmentPaid,
	expandGroups: ExpandGroups,
	shrinkGroups: ShrinkGroups,
	languageSwitcher: LanuageSwitcherIcon,
	arrow_left_round: ArrowLeftRound,
	arrow_right_round: ArrowRightRound,
	plus_user: PlusUser,
	search_gray: SearchGray,
	pfp_default2: PfpDefault2,
	search_not_found: SearchNotFound,
	newAppointment: NewAppointment,
	blockedTime: BlockedTime,
	recurringEvent: RecurringEvent,
	notes: Notes,
	landing_page_down: LandingPageDownArrow,
	landing_page_search: LandingPageSearch,
	landing_page_location: LandingPageLocation,

	s1: IconS01,
	s2: IconS02,
	s3: IconS03,
	s4: IconS04,
	s5: IconS05,
	s6: IconS06,
	s7: IconS07,
	s8: IconS08,
	s9: IconS09,
	s10: IconS10,
	s11: IconS11,
	s12: IconS12,
	s13: IconS13,
	s14: IconS14,
	s15: IconS15,
	s16: IconS16,
	s17: IconS17,
	s18: IconS18,
	s19: IconS19,
	s20: IconS20,

	marker_3: IconMarker_3,
};

export type IconName = keyof typeof icons;

const renderIcon = (
	icon: IconName,
	height?: number | undefined,
	width?: number | undefined,
	className?: string,
	onClick?: (e?: any) => void,
	circle?: boolean,
	key?: string,
) => {
	if (!icon || !(icon in icons)) {
		return null;
	}
	const Icon = icons[icon];

	return circle ? (
		<div className="circle" onClick={onClick} key={key}>
			<Icon
				height={height}
				width={width}
				className={`icon ${className ? className : ''} ${icons[icon].name === 'Liked' ? ' like' : ''}`}
			/>
		</div>
	) : (
		<Icon
			key={key}
			height={height}
			width={width}
			className={`icon ${className ? className : ''} ${icons[icon].name === 'Liked' ? ' like' : ''}`}
			onClick={onClick}
		/>
	);
};

export default renderIcon;
